import { render, staticRenderFns } from "./UploadedDokumenRegistrasi.vue?vue&type=template&id=6767835f&"
import script from "./UploadedDokumenRegistrasi.vue?vue&type=script&lang=js&"
export * from "./UploadedDokumenRegistrasi.vue?vue&type=script&lang=js&"
import style0 from "./UploadedDokumenRegistrasi.vue?vue&type=style&index=0&id=6767835f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
